var _path, _path2, _path3, _path4, _path5, _rect, _circle, _circle2, _circle3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle4, _path17, _circle5, _path18, _path19, _path20, _path21, _circle6, _path22, _path23, _circle7, _path24, _path25, _circle8, _circle9, _path26, _path27, _polygon, _path28, _polygon2, _path29, _path30, _path31, _path32, _path33, _circle10, _path34, _path35, _path36, _path37;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aaba0e37-9041-4e47-99c0-3bc98a69ed5f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 913.2141,
    height: 482.65195,
    viewBox: "0 0 913.2141 482.65195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M942.03244,631.5634a554.59191,554.59191,0,0,1-71.26188-5.22833c-.82939-.1145-1.65872-.23925-2.488-.35424l1.24755-223.2763c.82368-.65556,1.65726-1.30082,2.50079-1.926,2.79166-2.08453,5.66267-4.03825,8.6327-5.83174,14.30839-8.62038,31.06069-12.56688,42.61879-8.6121l.1796.07083a20.28144,20.28144,0,0,1,6.878,3.95841c10.14979,9.01681,8.45787,27.24788.26533,43.79221,16.24314-14.83916,36.73947-26.655,55.03481-27.55279,17.84517-.88029,30.59322,8.45085,41.42685,18.5716.35814.33208.70632.66411,1.05445.99614.17909.16116.34819.332.52728.4927,8.256,7.89635,16.39469,17.10212,15.41019,30.42691-1.08167,14.61381-13.32235,30.81618-27.58606,42.1766-14.2537,11.36048-30.4461,18.90977-46.24911,26.56183-15.79306,7.66188-31.98965,15.95139-45.48855,28.24628,21.06334-16.65259,45.02875-30.079,68.33686-35.03865s45.694-.59479,56.67128,14.24656a34.71258,34.71258,0,0,1,6.13511,15.20493c.10641.64025.1928,1.29064.26913,1.95124,1.56321,13.73893-3.18849,30.14281-14.54662,44.09958-12.50612,15.37031-31.04593,26.02665-48.64583,31.32879C975.35517,631.1695,958.41175,631.73451,942.03244,631.5634Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M869.06755,485.483l.02385-4.26946q1.27134-2.03346,2.51286-4.08612c.53471-.84713,1.04952-1.70413,1.57434-2.56156q12.97391-21.24278,24.88928-42.75125,11.92524-21.48888,22.75164-43.19386a1.78938,1.78938,0,0,1,2.04582-1.02863.51586.51586,0,0,1,.14957.07115c.37888.20183.5364.65291.21271,1.31127-.88994,1.77484-1.77993,3.55994-2.68988,5.33466q-11.01171,21.76427-23.12254,43.3417-12.10564,21.56257-25.28,42.87944c-.18166.29879-.37334.598-.555.89682C870.74264,482.78238,869.90509,484.12782,869.06755,485.483Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M868.76,540.53246l.01475-2.6401c.8333-.59545,1.6666-1.18065,2.5-1.7761q29.42769-20.98532,58.85537-41.96184,48.17767-34.35147,96.35524-68.68242a1.70023,1.70023,0,0,1,.58168-.297c.71113-.19574,1.1282.32662,1.05445.99614a2.00556,2.00556,0,0,1-.88781,1.395q-27.018,19.25925-54.016,38.50885-47.93672,34.17264-95.86329,68.33556c-2.02815,1.44865-4.06624,2.89725-6.09439,4.3459C870.42655,539.35181,869.5932,539.94726,868.76,540.53246Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M884.09154,599.349c-4.44933-.13473-8.82776-.42921-13.16564-.81381q-1.24443-.11169-2.48878-.22387l.01548-2.77c.82949.08472,1.65905.16943,2.48866.24389,6.26685.58532,12.60459,1.00062,19.11439,1.057a266.65608,266.65608,0,0,0,53.75014-5.24957,334.66588,334.66588,0,0,0,55.84172-16.25855,383.49442,383.49442,0,0,0,55.24953-26.60138,1.47563,1.47563,0,0,1,.98136-.24452c.78941.11427,1.02353,1.1654.26913,1.95124a2.29324,2.29324,0,0,1-.50223.3971q-3.29575,1.91667-6.61115,3.76341A383.22557,383.22557,0,0,1,993.591,580.06063a333.08038,333.08038,0,0,1-55.92559,15.15749A263.0737,263.0737,0,0,1,884.09154,599.349Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M862.09649,208.674h-607a8.72767,8.72767,0,0,0-8.71973,8.72V628.714a8.72767,8.72767,0,0,0,8.71973,8.72h607a8.71246,8.71246,0,0,0,6.63037-3.06,2.04577,2.04577,0,0,0,.18994-.24,8.1667,8.1667,0,0,0,1.25-2.11005,8.507,8.507,0,0,0,.65967-3.31V217.39406A8.72954,8.72954,0,0,0,862.09649,208.674Zm6.24023,420.04a6.17537,6.17537,0,0,1-1.03027,3.42,6.446,6.446,0,0,1-2.35987,2.12,6.18426,6.18426,0,0,1-2.85009.69h-607a6.23757,6.23757,0,0,1-6.23-6.23V217.39406a6.23757,6.23757,0,0,1,6.23-6.23005h607a6.23944,6.23944,0,0,1,6.24023,6.23005Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 104.22645,
    y: 34.94921,
    width: 621.95676,
    height: 2.49281,
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.41536,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146.91587,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.41638,
    cy: 18.6961,
    r: 7.47844,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M714.6961,301.326h-312a13,13,0,0,1,0-26h312a13,13,0,0,1,0,26Zm-312-24a11,11,0,0,0,0,22h312a11,11,0,0,0,0-22Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.30246,380.826h-28a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M438.30246,407.826h-61a8,8,0,0,1,0-16h61a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M410.30246,498.826h-28a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M443.30246,525.826h-61a8,8,0,0,1,0-16h61a8,8,0,1,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M594.30246,495.826h-28a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M627.30246,522.826h-61a8,8,0,1,1,0-16h61a8,8,0,1,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M591.30246,385.826h-28a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M624.30246,412.826h-61a8,8,0,0,1,0-16h61a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M778.30246,379.826h-28a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M811.30246,406.826h-61a8,8,0,0,1,0-16h61a8,8,0,0,1,0,16Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ccc"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.50782,
    cy: 177.65195,
    r: 30,
    fill: "#58a6f2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M341.90088,399.82617h-28a3.00328,3.00328,0,0,1-3-3v-21a3.00328,3.00328,0,0,1,3-3h7.88232a2.98116,2.98116,0,0,1,2.55518,1.42725l2.19824,3.57275h15.36426a3.00328,3.00328,0,0,1,3,3v16A3.00328,3.00328,0,0,1,341.90088,399.82617Zm-28-25a1.0013,1.0013,0,0,0-1,1v21a1.0013,1.0013,0,0,0,1,1h28a1.0013,1.0013,0,0,0,1-1v-16a1.0013,1.0013,0,0,0-1-1H325.41943l-2.78418-4.52441a.99411.99411,0,0,0-.852-.47559Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 368.50782,
    cy: 182.65195,
    r: 30,
    fill: "#58a6f2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M524.90088,410.32617h-26a3.00328,3.00328,0,0,1-3-3v-32a3.00328,3.00328,0,0,1,3-3h18.83935a3.00735,3.00735,0,0,1,1.8794.66162l7.16016,5.75391a2.9844,2.9844,0,0,1,1.12109,2.33838v26.24609A3.00328,3.00328,0,0,1,524.90088,410.32617Zm-26-36a1.0013,1.0013,0,0,0-1,1v32a1.0013,1.0013,0,0,0,1,1h26a1.0013,1.0013,0,0,0,1-1V381.08008a.99457.99457,0,0,0-.37354-.7793l-7.16113-5.75439a1.00207,1.00207,0,0,0-.626-.22022Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M519.90088,386.32617h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M519.90088,392.32617h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M519.90088,398.32617h-16a1,1,0,0,1,0-2h16a1,1,0,0,1,0,2Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.50782,
    cy: 176.65195,
    r: 30,
    fill: "#58a6f2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M710.90039,396.32617h-28a3.00328,3.00328,0,0,1-3-3v-16a3.00328,3.00328,0,0,1,3-3h28a3.00328,3.00328,0,0,1,3,3v16A3.00328,3.00328,0,0,1,710.90039,396.32617Zm-28-20a1.001,1.001,0,0,0-1,1v16a1.001,1.001,0,0,0,1,1h28a1.001,1.001,0,0,0,1-1v-16a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M696.90039,387.96436a3.00347,3.00347,0,0,1-1.58984-.45264l-14.94043-9.3374a1.00027,1.00027,0,0,1,1.06054-1.69629l14.94043,9.3374a1.00557,1.00557,0,0,0,1.05957,0l14.93946-9.3374a1.00027,1.00027,0,0,1,1.06054,1.69629l-14.93945,9.3374A3.00432,3.00432,0,0,1,696.90039,387.96436Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 184.50782,
    cy: 295.65195,
    r: 30,
    fill: "#58a6f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M341.90088,515.32617h-28a3.00328,3.00328,0,0,1-3-3v-16a3.00328,3.00328,0,0,1,3-3h28a3.00328,3.00328,0,0,1,3,3v16A3.00328,3.00328,0,0,1,341.90088,515.32617Zm-28-20a1.001,1.001,0,0,0-1,1v16a1.001,1.001,0,0,0,1,1h28a1.001,1.001,0,0,0,1-1v-16a1.001,1.001,0,0,0-1-1Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M337.46289,515.32617h-20.124a1.99958,1.99958,0,0,1-1.73194-3l6.06153-10.5a2.00022,2.00022,0,0,1,3.46435,0l3.915,6.78125,2.26807-3.92871a2.00022,2.00022,0,0,1,3.46435,0l4.415,7.64746a2,2,0,0,1-1.73242,3Zm0-2h0l-4.415-7.64746-3.13379,5.42871a.99985.99985,0,0,1-.86621.5h0a.99985.99985,0,0,1-.86621-.5l-4.78076-8.28125-6.062,10.5Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 195.50782,
    cy: 290.65195,
    r: 2,
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 370.50782,
    cy: 292.65195,
    r: 30,
    fill: "#58a6f2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M513.90088,501.82617a9,9,0,1,1,9-9A9.01016,9.01016,0,0,1,513.90088,501.82617Zm0-16a7,7,0,1,0,7,7A7.00818,7.00818,0,0,0,513.90088,485.82617Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M521.90088,518.82617h-16a3.50424,3.50424,0,0,1-3.5-3.5,11.5,11.5,0,1,1,23,0A3.50424,3.50424,0,0,1,521.90088,518.82617Zm-8-13a9.51081,9.51081,0,0,0-9.5,9.5,1.50164,1.50164,0,0,0,1.5,1.5h16a1.50164,1.50164,0,0,0,1.5-1.5A9.51081,9.51081,0,0,0,513.90088,505.82617Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80.937 471.198 93.197 471.198 99.029 423.91 80.935 423.911 80.937 471.198",
    fill: "#ffb8b8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M221.70288,676.36888h38.53073a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H236.58973a14.88686,14.88686,0,0,1-14.88686-14.88686v0A0,0,0,0,1,221.70288,676.36888Z",
    transform: "translate(338.57474 1158.93961) rotate(179.99738)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "34.937 471.198 47.197 471.198 53.029 423.91 34.935 423.911 34.937 471.198",
    fill: "#ffb8b8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M175.70288,676.36888h38.53073a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H190.58973a14.88686,14.88686,0,0,1-14.88686-14.88686v0a0,0,0,0,1,0,0Z",
    transform: "translate(246.57474 1158.94171) rotate(179.99738)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M179.8272,539.03387a10.7427,10.7427,0,0,0,2.06222-16.343l8.0725-114.55784-23.253,2.25509-.63868,112.18665a10.80091,10.80091,0,0,0,13.757,16.45913Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.69537,656.05548a4.5171,4.5171,0,0,1-4.46875-3.96582l-7.12622-59.60254a3.5,3.5,0,0,0-6.93287-.12793l-8.977,57.06738a4.47888,4.47888,0,0,1-4.44531,3.80078h-14.55a4.50047,4.50047,0,0,1-4.5-4.53418L180.63946,522.159a4.47381,4.47381,0,0,1,3.85351-4.41992l53.99366-7.83789a4.50111,4.50111,0,0,1,5.14648,4.48535l-.94189,136.55664a4.499,4.499,0,0,1-4.28589,4.46289l-13.49634.64356Q224.8017,656.05547,224.69537,656.05548Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.70269,526.93927a45.08471,45.08471,0,0,1-15.22583-2.71094,4.46544,4.46544,0,0,1-2.918-4.00488c-.46582-10.33692-3.19092-63.54395-11.12451-95.999a33.17817,33.17817,0,0,1,12.63647-34.57324q.64014-.46,1.30518-.90332a32.30589,32.30589,0,0,1,31.39551-2.46094,33.21917,33.21917,0,0,1,19.36352,25.957l12.9375,96.05078a4.47791,4.47791,0,0,1-.93115,3.40137,4.418,4.418,0,0,1-3.05347,1.67285c-4.48291.44727-13.78051,2.18457-25.67993,8.7959A38.12461,38.12461,0,0,1,196.70269,526.93927Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M180.886,447.32061l-21.29064-5.77256a4.50507,4.50507,0,0,1-3.16561-5.52077l7.48456-27.6049a12.39859,12.39859,0,0,1,24.34642,3.92684l-1.70385,30.87614a4.49955,4.49955,0,0,1-5.67088,4.09525Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1934,
    cy: 140.01002,
    r: 24.56103,
    fill: "#ffb8b8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M293.59007,396.93867a10.52582,10.52582,0,0,0-.23929,1.64013l-42.95745,24.782-10.44142-6.01094-11.13116,14.57228,22.33714,15.92056L300.1658,409.18a10.49579,10.49579,0,1,0-6.57573-12.24132Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#ffb8b8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M246.83315,424.5566l-18.5043,12.00854a4.50508,4.50508,0,0,1-6.22447-1.32511l-15.57-23.9922A12.3986,12.3986,0,0,1,225.7025,395.7316l21.8634,21.86849a4.49956,4.49956,0,0,1-.73275,6.95651Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M187.20575,368.11561c4.582,4.88078,13.09132,2.26067,13.68835-4.40717a8.05557,8.05557,0,0,0-.01013-1.5557c-.30827-2.95357-2.01461-5.635-1.60588-8.7536a4.59057,4.59057,0,0,1,.84011-2.14891c3.65124-4.88934,12.22227,2.18687,15.6682-2.2393,2.113-2.714-.3708-6.98712,1.25066-10.0205,2.14005-4.00358,8.47881-2.0286,12.45387-4.22116,4.42275-2.43948,4.15822-9.22524,1.24686-13.35269-3.55052-5.03359-9.77572-7.71951-15.92335-8.10661s-12.25292,1.27475-17.9923,3.51145c-6.52108,2.54134-12.98768,6.05351-17.00066,11.78752-4.88022,6.97317-5.34986,16.34794-2.90917,24.50175C178.397,358.07074,183.46408,364.12993,187.20575,368.11561Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#2f2e41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M284.393,691.326h-140a1,1,0,0,1,0-2h140a1,1,0,1,1,0,2Z",
    transform: "translate(-143.39295 -208.67402)",
    fill: "#3f3d56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSap);
export default __webpack_public_path__ + "static/media/sap.b8acc0e5.svg";
export { ForwardRef as ReactComponent };